import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Youtube, Linkedin } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="mt-24 border-t border-border bg-peda-navy text-slate-300">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="grid place-items-center h-11 w-11 rounded-lg bg-[hsl(var(--primary))] text-white font-bold text-xs">PEDA</div>
            <div>
              <div className="font-heading font-semibold text-white">PEDA</div>
              <div className="text-xs opacity-70">Government of Punjab</div>
            </div>
          </div>
          <p className="mt-4 text-sm opacity-80 max-w-xs">
            State nodal agency accelerating Punjab&apos;s clean energy transition — solar, biogas, CBG, waste-to-energy and EV infrastructure.
          </p>
          <div className="mt-5 flex gap-3">
            {[Facebook, Twitter, Youtube, Linkedin].map((I, i) => (
              <a key={i} href="#social" aria-label="social" className="grid place-items-center h-9 w-9 rounded-full bg-white/5 hover:bg-white/10 transition-colors">
                <I className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="label-tiny text-slate-400">Quick Links</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About PEDA</Link></li>
            <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
            <li><Link to="/tenders" className="hover:text-white">Tenders</Link></li>
            <li><Link to="/downloads" className="hover:text-white">Downloads</Link></li>
            <li><Link to="/gis" className="hover:text-white">GIS Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-tiny text-slate-400">Citizen Services</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/services/solar_rooftop" className="hover:text-white">Solar Rooftop</Link></li>
            <li><Link to="/services/ev" className="hover:text-white">EV Schemes</Link></li>
            <li><Link to="/services/subsidy" className="hover:text-white">Subsidy Applications</Link></li>
            <li><Link to="/grievance" className="hover:text-white">Register Grievance</Link></li>
            <li><Link to="/rti" className="hover:text-white">File RTI</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-tiny text-slate-400">Contact</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 opacity-70"/> Plot No. 1-2, Sector 33-D,<br/>Chandigarh 160034, India</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 opacity-70"/> +91-172-2663328</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 opacity-70"/> info@peda.gov.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-4 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Punjab Energy Development Agency · Government of Punjab</div>
          <div className="flex gap-4 mt-2 md:mt-0">
            <Link to="/about#privacy" className="hover:text-white">Privacy</Link>
            <Link to="/about#terms" className="hover:text-white">Terms</Link>
            <Link to="/about#accessibility" className="hover:text-white">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
